import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AddressIPsModule } from './address-ips.module';

@Injectable({
  providedIn: 'root'
})
export class AddressIPsService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
  };

  private headers: HttpHeaders;
  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
  }

  formData: AddressIPsModule = new AddressIPsModule();
  list: AddressIPsModule[];

  postService() {
    return this.http.post(environment.apiURL + 'POS/Web/WBAddessIPs/', this.formData);
  }

}
